"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGenerator = exports.update = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
// export type GameModeType = 'init' | 'loading' | 'main'
var namespace = 'generator-manager';
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function create() {
    var obj = {
        generator: null,
        generator_exit: null,
        generatorPauseSeconds: 0,
        isPaused: false,
        // mode: 'init',
    };
    return obj;
}
function update() {
    var obj = get();
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.generatorPauseSeconds > 0) {
        obj.generatorPauseSeconds -= ds;
        return;
    }
    if (obj.generator) {
        var generatorResult = obj.generator.next();
        if (generatorResult.done) {
            console.log(namespace, 'Generator is done!');
            obj.generator = null;
        }
        else {
            obj.generatorPauseSeconds = generatorResult.value || 0;
        }
    }
}
exports.update = update;
function exitCurrentMode() {
    var obj = get();
    if (obj.generator_exit) {
        obj.generator_exit();
        obj.generator_exit = null;
    }
}
function setGenerator(generator, generatorExit) {
    if (generatorExit === void 0) { generatorExit = function () { }; }
    var obj = get();
    exitCurrentMode();
    obj.generator = generator;
    obj.generator_exit = generatorExit;
}
exports.setGenerator = setGenerator;
